// Copyright (c) 2026 PGNS LLC

import { AlertTriangle } from 'lucide-react';

/**
 * Shown when the status API could not be reached.
 *
 * Deliberately says nothing about whether pgns itself is up: this page failed
 * to read its own data source, which is a different claim, and inventing an
 * outage from a monitoring failure is the one mistake a status page cannot make.
 */
export function DataUnavailable({ stale }: { stale: boolean }) {
  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-brand border border-brand-bronze/40 bg-brand-bronze/10 p-4"
    >
      <AlertTriangle className="size-4 mt-0.5 shrink-0 text-brand-bronze" aria-hidden="true" />
      <div className="text-sm">
        <p className="font-medium text-foreground">Status data unavailable</p>
        <p className="text-muted-foreground">
          {stale
            ? 'The status API did not answer the last refresh. The figures below are the most recent ones we retrieved and may be out of date.'
            : 'The status API did not answer. This says nothing about whether pgns itself is available — it means this page could not read its data source.'}
        </p>
      </div>
    </div>
  );
}
